import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { IRequestCommand } from '../../authentication/connection/iRequestCommand';

export class GetDriverLocationCommand extends IRequestCommand<
  IGetDriverLocationCommandParametersResponse,
  ErrorDetails,
  IGetDriverLocationCommandParametersResponse
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public setDriverId(driverUserId: number): void {
    this.urlSections.push(`drivers`);
    this.urlSections.push(`${driverUserId}`);
    this.urlSections.push(`reportLocation`);
    this.composeUrl();
  }
}


export interface IGetDriverLocationCommandParametersResponse
  extends ICommandResponse {}

export interface IGetDriverLocationCommandParameters
  extends ICommandParameters { }

